import { createContext, useContext } from 'react';

import { FlowDefinitionModel } from '../../Models/FlowModel';

export type FlowSchemaContextValue = {
	flow: FlowDefinitionModel;
	onFlowChanged: (flow: FlowDefinitionModel) => void;
	usageCounts: ReadonlyMap<string, number>;
};

export const FlowSchemaContext = createContext<FlowSchemaContextValue | undefined>(undefined);

export function useFlowSchemaContext() {
	return useContext(FlowSchemaContext);
}
